<template>
	<div class="content-wrap">
		<template>
			<a-form-model
				layout="inline"
				:label-col="{ span: 8 }"
				:wrapper-col="{ span: 16 }"
				class="customer-list-form"
				:colon="false"
			>
				<a-form-model-item :label="$t('locationList.factoryName')">
					<a-auto-complete
						v-model.trim="params.condition.name"
						:placeholder="$t('locationList.factoryName')"
						size="small"
						:allowClear="true"
						:data-source="dataSourceName"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('locationList.address')">
					<a-auto-complete
						v-model.trim="params.condition.address"
						:placeholder="$t('locationList.address')"
						size="small"
						:allowClear="true"
						:data-source="dataSourcebAddress"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('locationList.contactName')">
					<a-auto-complete
						v-model.trim="params.condition.locationContactName"
						:placeholder="$t('locationList.contactName')"
						size="small"
						:allowClear="true"
						:data-source="dataSourceContactName"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('locationList.contactNumber')">
					<a-auto-complete
						v-model.trim="params.condition.locationContactPhone"
						:placeholder="$t('locationList.contactNumber')"
						size="small"
						:allowClear="true"
						:data-source="dataSourceContactPhone"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						@click="search"
						size="small"
						style="marginLeft:10px;"
					>
						{{ $t('search') }}
					</a-button>
				</a-form-model-item>
				<a-form-model-item>
					<a-button @click="resetSearch" size="small">
						{{ $t('reset') }}
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</template>

		<a-modal
			:title="isAdd ? $t('locationList.addFactoryInfo') : $t('locationList.updateFactoryInfo')" 
			:visible="visible_driverform"
			@cancel="canceldriverform"
		>
			<a-form-model
				ref="locationRef"
				:model="addLocationReq"
				:label-col="{ span: 6 }"
				:wrapper-col="{ span: 14 }"
			>
				<a-form-model-item :label="$t('locationList.factoryName')" prop="factoryName">
					<a-input
						allowClear
						v-model.trim="addLocationReq.factoryName"
						style="width: 200px"
						:placeholder="$t('locationList.factoryName')"
					>
					</a-input>
				</a-form-model-item>
				<a-form-model-item :label="$t('locationList.address')" prop="factoryAddress">
					<a-textarea
						style="width: 200px"
						allow-clear
						v-model.trim="addLocationReq.factoryAddress"
						:placeholder="$t('locationList.address')"
						:auto-size="{ minRows: 2, maxRows: 6 }"
						class="location-textarea"
					>
					</a-textarea>
				</a-form-model-item>
				<template v-for="(item, index) in addLocationReq.locationContacts">
					<div :key="index" class="ediable-contact">
						<a-form-model-item
							:label="$t('locationList.contactName') + (index + 1)"
							:prop="'contactName' + index"
						>
							<a-input
								allowClear
								v-model.trim="item.contactName"
								style="width: 200px"
								:placeholder="$t('locationList.contactName')"
							>
							</a-input>
							<a-icon
								v-if="addLocationReq.locationContacts.length > 1"
								class="dynamic-delete-button"
								type="minus-circle-o"
								:disabled="addLocationReq.locationContacts.lenght === 1"
								@click="removeDomain(item)"
							/>
						</a-form-model-item>
						<a-form-model-item
							:label="$t('locationList.contactNumber') + (index + 1)"
							:prop="'contactPhone' + index"
						>
							<a-input
								allowClear
								v-model.trim="item.contactPhone"
								style="width: 200px"
								:placeholder="$t('locationList.contactNumber')"
							>
							</a-input>
						</a-form-model-item>
					</div>
				</template>

				<a-form-model-item v-bind="formItemLayoutWithOutLabel">
					<a-button type="dashed" style="width: 60%" @click="addDomain">
						<a-icon type="plus" /> {{ $t('locationList.continueAddingContacts') }}
					</a-button>
				</a-form-model-item>
			</a-form-model>
			<template slot="footer" v-if="isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_driver"
					@click="okAddLocation"
				>
					{{ $t('sure') }}
				</a-button>
				<a-button key="back" @click="resetLocation">{{ $t('reset') }}</a-button>
			</template>
			<template slot="footer" v-if="!isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_driver"
					@click="okAddLocation"
				>
					{{ $t('update') }}
				</a-button>
				<a-button key="back" @click="resetLocation">{{ $t('reset') }}</a-button>
			</template>
		</a-modal>
		<!-- table展示 -->
		<div class="table-area">
			<table-fixed
				:tableData="tableData"
				:tableColumn="columns"
				:columnSettingsKey="$route.name"
				:pagination="pagination"
				:loading="loading"
			>
				<template v-slot:toolbar>
					<a-button type="primary" size="small" @click="showbox">
						{{ $t('locationList.addFactoryInfo') }}
					</a-button>
				</template>
				<template v-slot:option="scope">
					<a-button @click="showUpdate(scope.driver)">{{ $t('edit') }}</a-button>
				</template>
			</table-fixed>
		</div>
	</div>
</template>
<script>
import tableFixed from "../../components/table-fixed.vue";
import { locationlist, addLocation, updateLocation } from "../../api/basicData";
// import { locationlist } from "../../api/basicData";
import { columns } from "./location-list";
import { searchReqParam } from "../../utils/searchReqParam";
import i18n from '@/locales/i18n'

let initLocationReq = {
	currentUserCompanyId: "",
	currentUserId: "",
	factoryAddress: "",
	factoryName: "",
	locationType: "FACTORY",
	locationContacts: [
		{
			contactName: "",
			contactPhone: "",
		},
	],
};
let locationType = [
	{
		code: "PORT",
		value: i18n.t('businessDispatch.portArea'),
	},
	{
		code: "FACTORY",
		value: i18n.t('locationList.factory'),
	},
	{
		code: "DEPOT",
		value: i18n.t('businessDispatch.yard'),
	},
];
export default {
	name: "business-dispatch",
	components: { tableFixed },
	data() {
		return {
			columns,
			req: searchReqParam(),
			tableData: [],
			params: {
				condition: {
					address: "",
					companyId: "",
					// locationContactName: "",
					// locationContactPhone: "",
					locationType: "FACTORY",
					name: "",
				},
				page: 1,
				pageSize: 10,
			},
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			loading: false,
			isAdd: false,
			visible_driverform: false,
			confirmLoading_driver: false,
			locationType,
			addLocationReq: {},
			initLocationReq,
			formItemLayout: {
				labelCol: {
					xs: { span: 12 },
					sm: { span: 6 },
				},
				wrapperCol: {
					xs: { span: 18 },
					sm: { span: 14 },
				},
			},
			formItemLayoutWithOutLabel: {
				wrapperCol: {
					xs: { span: 20, offset: 0 },
					sm: { span: 18, offset: 4 },
				},
			},
			dynamicValidateForm: {
				domains: [],
			},
			rules: {
				factoryName: [
					{ required: true, message: this.$t('locationList.factoryNameCannotBeEmpty'), trigger: "blur" },
					// { max: 45, message: "不能超过45个字符", trigger: "change" },
				],
				locationType: [
					{ required: true, message: this.$t('locationList.pleaseSelectFactoryType'), trigger: "blur" },
				],
				factoryAddress: [
					{ required: true, message: this.$t('locationList.factoryAddressCannotBeEmpty'), trigger: "blur" },
					// { max: 200, message: "不能超过200个字符", trigger: "change" },
				],
			},
			dataSourceName: [],
			dataSourcebAddress: [],
			dataSourceContactName: [],
			dataSourceContactPhone: [],
		};
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		pageInit() {
			this.req.params = this.params;
			this.loading = true;
			locationlist(this.req).then((res) => {
				let resData = JSON.parse(res.data);
				if (!resData.success || resData.code != "0") {
					this.$message.error(resData.msg);
					return;
				}
				this.tableData = resData.data.list;
				this.pagination.total = resData.data.total;
				this.loading = false;
			});
		},
		// 搜索
		search() {
			this.pagination.onChange(1); 
		},
		// 重置搜索
		resetSearch() {
			this.params.condition = {};
		},
		// 点击新增工厂信息按钮弹框
		showbox() {
			this.isAdd = true;
			// 新增时的初始化数据
			// this.addLocationReq = {
			// 	...this.initLocationReq,
			// };
			this.addLocationReq = JSON.parse(JSON.stringify(this.initLocationReq));
			// // 解决数组浅拷贝
			// this.addLocationReq.locationContacts = [
			// 	// ...this.initLocationReq.locationContacts,
			// ];
			this.visible_driverform = true;
		},
		// 取消 新增 / 更新
		canceldriverform() {
			this.visible_driverform = false;
			this.confirmLoading_driver = false;
			this.initLocationReq = {
				currentUserCompanyId: "",
				currentUserId: "",
				factoryAddress: "",
				factoryName: "",
				locationType: "FACTORY",
				locationId: "",
				locationContacts: [
					{
						contactName: "",
						contactPhone: "",
					},
				],
			};
			// 清楚表单验证结果
			this.$refs["locationRef"].clearValidate();
		},
		// 重置 新增 / 更新
		resetLocation() {
			// 重置表单的数据为初始化数据 -- 两个不同的对象，数据独立
			console.log(this.initLocationReq);
			// this.addLocationReq = {
			// 	...this.initLocationReq,
			// };
			this.addLocationReq = JSON.parse(JSON.stringify(this.initLocationReq));
			// 解决数组浅拷贝
			// this.addLocationReq.locationContacts = [
			// 	...this.initLocationReq.locationContacts,
			// ];
		},
		// 确定 新增 / 更新
		okAddLocation() {
			this.req.params = this.addLocationReq;

			// 新增
			let R = this.req.params;
			if (R.factoryName == "") {
				this.$message.warn(this.$t('locationList.pleaseEnterFactoryName'));
				return;
			}
			// if (R.factoryName.length > 45) {
			// 	this.$message.warn("工厂名称字数不超过45个");
			// 	return;
			// }
			// if (R.locationType == "" || R.locationType == undefined) {
			// 	this.$message.warn("请选择工厂类型");
			// 	return;
			// }
			if (R.factoryAddress == "") {
				this.$message.warn(this.$t('locationList.pleaseEnterFactoryAddress'));
				return;
			}
			// if (R.factoryAddress.length > 200) {
			// 	this.$message.warn("工厂地址字数不超过200个");
			// 	return;
			// }
			let flag = false;
			if (R.locationContacts) {
				R.locationContacts.forEach((item) => {
					if (item.contactName == "" || item.contactPhone == "") {
						this.$message.warn(this.$t('locationList.nameAndPhoneCannotBeEmpty'));
						flag = true;
						throw new Error("end iterate");
					}
					// if (item.contactName.length > 45) {
					// 	this.$message.warn("联系人姓名不能超过45个字符");
					// 	flag = true;
					// 	throw new Error("end iterate");
					// }
					// if (item.contactPhone.length > 30) {
					// 	this.$message.warn("手机号不能超过30个字符");
					// 	flag = true;
					// 	throw new Error("end iterate");
					// }
					// if (item.contactPhone.trim().length < 3 && item.contactPhone.trim().length > 20) {
					// 	this.$message.warn("请输入正确的手机号");
					// 	flag = true;
					// 	throw new Error("end iterate");
					// }
					let repeat = R.locationContacts.filter((ele) => {
						return item.contactPhone == ele.contactPhone;
					});
					console.log("repeat ==== ", repeat);
					if (repeat.length >= 2) {
						this.$message.warn(
							this.$t('locationList.repeatPhonePrompt')
						);
						flag = true;
						throw new Error("end iterate");
					}
				});
				if (flag) return;
			}

			if (this.isAdd) {
				addLocation(this.req).then((res) => {
					console.log(res.data);
					let result = JSON.parse(res.data);
					if (!result.success) {
						this.$message.error(result.msg);
						return;
					}
					if (result.success && result.code == "0") {
						// 成功提示信息
						this.$message.success(result.msg);
						// 关闭新增窗口
						this.canceldriverform();
						// 重置新增参数 -- 参数重置现在放到了入口
						// this.resetLocation();
						// 刷新列表数据
						this.pageInit();
					} else {
						this.$message.error(this.$t('locationList.addressAlreadyExistsPrompt'));
						// this.$message.error(result.msg);
					}
				});
				return;
			}

			// 更新
			// this.req.params.locationId = this.locationId;
			console.log(this.req);

			updateLocation(this.req).then((res) => {
				console.log(res.data);
				let result = JSON.parse(res.data);
				if (result.success && result.code == "0") {
					// 成功提示信息
					this.$message.success(result.msg);
					// 关闭新增窗口
					this.canceldriverform();
					// 重置新增参数 -- 参数重置现在放到了入口
					// this.resetLocation();
					// 刷新列表数据
					this.pageInit();
				} else {
					this.$message.error(this.$t('locationList.addressAlreadyExistsPrompt'));
					// this.$message.error(result.msg);
				}
			});
		},
		// 点击编辑按钮
		showUpdate(driver) {
			console.log(driver);
			// this.locationId = driver.id;
			// 封装联系人数据
			let locationContacts = [
				{
					contactName: "",
					contactPhone: "",
				},
			];
			let locationContactName = driver.locationContactName;
			let locationContactPhone = driver.locationContactPhone;
			if (locationContactName) {
				let names = locationContactName.split(",");
				console.log(names);
				let phones = [];
				if (locationContactPhone) {
					phones = locationContactPhone.split(",");
				}
				console.log(phones);
				names.forEach((ele, index) => {
					let phone = "";
					if (phones[index]) {
						phone = phones[index];
					}
					if (locationContacts[index]) {
						locationContacts[index].contactName = ele;
						locationContacts[index].contactPhone = phone;
					} else {
						locationContacts.push({
							contactName: ele,
							contactPhone: phone,
						});
					}
				});
			}
			this.isAdd = false;
			this.initLocationReq = {
				currentUserCompanyId: driver.companyId,
				currentUserId: "",
				locationId: driver.id,
				factoryAddress: driver.address,
				factoryName: driver.name,
				locationType: "FACTORY",
				locationContacts: locationContacts,
			};
			this.addLocationReq = JSON.parse(JSON.stringify(this.initLocationReq));
			this.visible_driverform = true;
		},
		// 移除
		removeDomain(item) {
			let index = this.addLocationReq.locationContacts.indexOf(item);
			if (index !== -1) {
				this.addLocationReq.locationContacts.splice(index, 1);
			}
		},
		// 添加
		addDomain() {
			this.addLocationReq.locationContacts.push({
				contactName: "",
				contactPhone: "",
			});
		},

		onChangeSource(searchText) {
			console.log(this.req);
			locationlist(this.req).then((res) => {
				let temp = JSON.parse(res.data).data.list;
				// 名称
				this.dataSourceName = [];
				temp.forEach((item) => {
					if (this.dataSourceName.indexOf(item.name) == -1) {
						this.dataSourceName.push(item.name);
					}
				});
				this.dataSourceName = !searchText ? [] : this.dataSourceName;

				// 地址
				this.dataSourcebAddress = [];
				temp.forEach((item) => {
					if (this.dataSourcebAddress.indexOf(item.address) == -1) {
						this.dataSourcebAddress.push(item.address);
					}
				});
				this.dataSourcebAddress = !searchText ? [] : this.dataSourcebAddress;

				// 工厂联系人名称
				this.dataSourceContactName = [];
				temp.forEach((item) => {
					if (
						this.dataSourceContactName.indexOf(item.locationContactName) == -1
					) {
						this.dataSourceContactName.push(item.locationContactName);
					}
				});
				this.dataSourceContactName = !searchText
					? []
					: this.dataSourceContactName;

				// 工厂联系人电话
				this.dataSourceContactPhone = [];
				temp.forEach((item) => {
					if (
						this.dataSourceContactPhone.indexOf(item.locationContactPhone) == -1
					) {
						this.dataSourceContactPhone.push(item.locationContactPhone);
					}
				});
				this.dataSourceContactPhone = !searchText
					? []
					: this.dataSourceContactPhone;
			});
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
	max-height: 600px;
	overflow: auto;
}
.ediable-contact {
	position: relative;
	height: auto;
	margin-right: 0;
	margin-left: 0;
	zoom: 1;
	display: block;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.dynamic-delete-button {
	cursor: pointer;
	position: absolute;
	top: 4px;
	right: -15%;
	font-size: 20px;
	color: #999;
	transition: all 0.3s;
}
.dynamic-delete-button:hover {
	color: #777;
}
.dynamic-delete-button[disabled] {
	cursor: not-allowed;
	opacity: 0.5;
}
.location-textarea {
	::-webkit-scrollbar {
		width: 0px;
		height: 8px;
	}
}
</style>
